import React from 'react'
import PeriodSearch from 'components/molcules/PeriodSearch'
import {dateToPeriodString, getMonthDefaultPeriodDate} from 'helpers/dateHelper'
import InstitutionSearch from 'pages/CustomerManagement/InvoiceList/InstitutionSearch'
import useTableToolbarStyles from 'components/Table/useTableToolbarStyles'

interface TableSearchProps {
  isRoot: boolean
  query: any
  onSearch: any
  search?: CustomerSearchKind
  children?: any
}

function TableCustomerSearch(props: TableSearchProps) {
  const {isRoot, query, onSearch, search, children} = props
  const classes = useTableToolbarStyles()
  const [selection] = React.useState<PeriodDate>(getMonthDefaultPeriodDate())

  // Search By Date period
  const handlePeriod = (period: PeriodDate) => {
    const formatedPeriod = dateToPeriodString(period)
    if (
      formatedPeriod.startDate === query.from &&
      formatedPeriod.endDate === query.to
    ) {
      return
    }
    const {startDate, endDate} = dateToPeriodString(period)
    onSearch({
      ...query,
      from: startDate,
      to: endDate,
    })
  }

  return (
    <div className={classes[isRoot ? 'root' : 'container']}>
      <PeriodSearch period={selection} onSearch={handlePeriod} />
      <InstitutionSearch />
      {children}
    </div>
  )
}

export default TableCustomerSearch
